import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { IMG_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf'; // Import jsPDF
import 'jspdf-autotable'; // Import for table support
import * as XLSX from 'xlsx'; // Import xlsx for Excel export

const SafeModuleList = () => {
    const [safeModules, setSafeModules] = useState([]);
    const [filteredSafeModules, setFilteredSafeModules] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}safemodule`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setSafeModules(data.data); // Store the safe modules data
                    setFilteredSafeModules(data.data); // Set initial filtered safe modules
                } else {
                    alert('Error fetching safe modules');
                }
            })
            .catch(error => console.error('Error fetching safe modules:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
    };

    const handleDateChange = (start, end) => {
        setStartDate(start);
        setEndDate(end);
    };

    const formatDate = (date) => {
        const d = new Date(date);
        return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`;
    };

    const filterSafeModules = () => {
        const filtered = safeModules.filter(safeModule => {
            const matchesSearch = safeModule.date.includes(searchTerm);

            const moduleDate = new Date(safeModule.date);
            const matchesDate =
                (!startDate || moduleDate >= new Date(startDate)) &&
                (!endDate || moduleDate <= new Date(endDate));

            return matchesSearch && matchesDate;
        });
        setFilteredSafeModules(filtered);
    };

    const handleFilter = () => {
        filterSafeModules();
    };

    const handleEdit = (id) => {
        navigate(`/EditSafeModule/${id}`);
    };

    const handleAdd = () => {
        navigate('/AddSafeModule');
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this safe module?")) {
            fetch(`${BASE_URL}safemodule/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        setSafeModules(safeModules.filter(safeModule => safeModule.id !== id));
                        setFilteredSafeModules(filteredSafeModules.filter(safeModule => safeModule.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting safe module:', error));
        }
    };

    const handleExportPDF = () => {
        const doc = new jsPDF();
        doc.text('Safe Module List', 14, 10);

        const tableData = filteredSafeModules.map(safeModule => [
            safeModule.id,
            formatDate(safeModule.date),
            JSON.parse(safeModule.images).map((image, index) => `${BASE_URL}${image}`).join(', '),
            safeModule.cash,
            safeModule.fine
        ]);

        doc.autoTable({
            head: [['ID', 'Date', 'Images', 'Cash', 'Fine']],
            body: tableData,
        });

        doc.save('safe_module_list.pdf');
    };

    const handleExportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredSafeModules.map(safeModule => ({
            ID: safeModule.id,
            Date: formatDate(safeModule.date),
            Images: JSON.parse(safeModule.images).map((image, index) => `${BASE_URL}${image}`).join(', '),
            Cash: safeModule.cash,
            Fine: safeModule.fine
        })));
        
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Safe Module List");

        XLSX.writeFile(workbook, 'safe_module_list.xlsx');
    };

    // Calculate Total Cash and Total Fine
    const totalCash = filteredSafeModules.reduce((total, safeModule) => total + parseFloat(safeModule.cash || 0), 0);
    const totalFine = filteredSafeModules.reduce((total, safeModule) => total + parseFloat(safeModule.fine || 0), 0);

    return (
      <div id="main">
        <header className="mb-3">
          <a href="#" className="burger-btn d-block d-xl-none">
            <i className="bi bi-justify fs-3"></i>
          </a>
        </header>

        <div className="page-heading">
          <div className="page-title">
            <div className="row">
              <div className="col-12 col-md-6 order-md-1 order-last">
                <h3>Safe Module List</h3>
              </div>
            </div>
          </div>
        </div>

        <section className="section">
          <div className="row" id="basic-table">
            <div className="col-12 col-md-12">
              <div className="card">
                <div className="card-header">
                  <div className="row">
                    <div className="col-md-6">
                      {/* Display total cash and fine */}
                      <div>
                        {/* <strong>Total Cash: </strong>{totalCash.toFixed(2)} */}
                      </div>
                      <div>
                        {/* <strong>Total Fine: </strong>{totalFine.toFixed(2)} */}
                      </div>
                    </div>
                    <div className="col-md-6 text-end">
                      <button className="btn btn-primary" onClick={handleAdd}>
                        Add Safe Module
                      </button>
                      <button
                        className="btn btn-secondary ms-2"
                        onClick={handleExportPDF}
                      >
                        Export to PDF
                      </button>
                      {/* <button className="btn btn-secondary ms-2" onClick={handleExportExcel}>Export to Excel</button> */}
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-3">
                    <div className="col-md-4">
                      <label htmlFor="searchTerm" className="form-label">
                        Search by Date
                      </label>
                      <input
                        type="text"
                        id="searchTerm"
                        className="form-control"
                        placeholder="Search by date"
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="startDate" className="form-label">
                        Start Date
                      </label>
                      <input
                        type="date"
                        id="startDate"
                        className="form-control"
                        value={startDate}
                        onChange={(e) =>
                          handleDateChange(e.target.value, endDate)
                        }
                      />
                    </div>

                    <div className="col-md-4">
                      <label htmlFor="endDate" className="form-label">
                        End Date
                      </label>
                      <input
                        type="date"
                        id="endDate"
                        className="form-control"
                        value={endDate}
                        onChange={(e) =>
                          handleDateChange(startDate, e.target.value)
                        }
                      />
                    </div>
                  </div>

                  <div className="row mb-3">
                    <div className="col-12">
                      <button
                        className="btn btn-secondary"
                        onClick={handleFilter}
                      >
                        Apply Filter
                      </button>
                    </div>
                  </div>

                  <div className="table-responsive mt-3">
                    <table className="table table-lg">
                      <thead>
                        <tr>
                          {/* <th>ID</th> */}
                          <th>Date</th>
                          <th>Images</th>
                          <th>Cash</th>
                          <th>Fine</th>
                          <th className="text-end">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredSafeModules.map((safeModule) => (
                          <tr key={safeModule.id}>
                            {/* <td>{safeModule.id}</td> */}
                            <td>{formatDate(safeModule.date)}</td>
                            <td>
                              {JSON.parse(safeModule.images).map(
                                (image, index) => (
                                  <img
                                    key={index}
                                    src={`https://pbhrm.com/${image}`}
                                    alt={`safe module ${safeModule.id} image ${
                                      index + 1
                                    }`}
                                    width="100"
                                    height="100"
                                    className="me-2"
                                  />
                                )
                              )}
                            </td>
                            <td>{safeModule.cash}</td>
                            <td>{safeModule.fine}</td>
                            <td className="text-end">
                              <button
                                className="btn btn-success"
                                onClick={() => handleEdit(safeModule.id)}
                              >
                                Edit
                              </button>
                              {/* <button className="btn btn-danger ms-2" onClick={() => handleDelete(safeModule.id)}>Delete</button> */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
};

export default SafeModuleList;
